module.exports = __webpack_public_path__ + "static/img/clause_letter117.187849d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/book/clause_letter117.png
// module id = By7I
// module chunks = 1